import { ORDER_WITH_ITEMS } from '@pulse/fixtures/orders.fixtures';
import { storeToRefs } from 'pinia';

import { useOrdersStore } from '~/store/orders';

export default defineNuxtRouteMiddleware(to => {
  const store = useOrdersStore();

  const { currentOrder } = storeToRefs(store);

  if (Object.hasOwn(to.query, 'fake')) {
    currentOrder.value = ORDER_WITH_ITEMS;
  }

  if (to.path === '/start') {
    return store.reset();
  }

  if (to.path.includes('return')) {
    return;
  }

  if (to.path.includes('in-store')) {
    if (!currentOrder.value) {
      return;
    }

    return navigateTo('/start');
  }

  if (!currentOrder.value && !(to.path.includes('/view') || to.path.includes('/print')) && !to.path.includes('/sign')) {
    return navigateTo('/start');
  }
});
